import { Routes, RouterModule, Router }  from '@angular/router';

import { Login } from './login.component';
import { ModuleWithProviders } from '@angular/core';

// noinspection TypeScriptValidateTypes
export const routes: Routes = [
  {
    path: '',
    component: Login
  },
  {
    path:'/:id',
    component:Login
  }
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);
